import { PropsWithChildren } from 'react';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { InstallmentStatus, PledgeFormValue } from 'assets/js/pages/pledges/usePledgeForm';
import { useGivebutterFormContext } from 'components/form';
import { useForceRender } from 'customHooks/useForceRender';

interface EditPaidInstallmentDialogProps extends PropsWithChildren {
    index: number;
}
const EditPaidInstallmentDialog = ({ children, index }: EditPaidInstallmentDialogProps) => {
    const { key, forceRender } = useForceRender();
    const { setValue } = useGivebutterFormContext<PledgeFormValue>();

    const onConfirm = () => {
        setValue(`installments.${index}.status`, InstallmentStatus.Late);
        forceRender();
    };

    return (
        <AlertDialog.Root key={key} type="warning">
            {children}
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon customIcon={faExclamationTriangle} />
                        <AlertDialog.Close />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>
                            Are you sure you want to edit a paid installment?
                        </AlertDialog.Title>
                        <AlertDialog.Description>
                            This may disrupt your installment schedule.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>Cancel</AlertDialog.Cancel>
                        <AlertDialog.Action
                            onClick={e => {
                                e.preventDefault();
                                onConfirm();
                            }}
                        >
                            Continue
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const Root = EditPaidInstallmentDialog;
const EditPaidInstallmentDialogTrigger = AlertDialog.Trigger;
const Trigger = EditPaidInstallmentDialogTrigger;

export {
    Root,
    Trigger,
    //
    EditPaidInstallmentDialog,
    EditPaidInstallmentDialogTrigger,
};
